<div class="bg-m0 flex select-none flex-col p-9">
  <div class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Edit Session Title</div
  >

  <form class="flex flex-col" [formGroup]="editTitleForm" (ngSubmit)="save()">
    <input
      autocomplete="off"
      #titleInput
      spellcheck="false"
      class="form-input border-s3 focus:border-m600 mt-9 rounded"
      [ngClass]="{
        'border-r600':
          editTitleForm.controls['title'].invalid &&
          editTitleForm.controls['title'].touched
      }"
      formControlName="title"
      placeholder="Title"
    />
    <m-validation [control]="editTitleForm.controls['title']"></m-validation>

    <div class="mt-6">
      <button
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        type="submit"
        >Save</button
      >

      <button
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>
